import React, { useState } from "react"
import { Modal as MaterialModal } from "@material-ui/core"
import { withStyles } from '@material-ui/core/styles'
import { makeStyles } from "@material-ui/core"
import Dialog from '@material-ui/core/Dialog'
import MuiDialogTitle from '@material-ui/core/DialogTitle'
import Typography from '@material-ui/core/Typography'
import IconButton from '@material-ui/core/IconButton'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles({
    title: {
        padding: '10px 16px',
        borderBottom: '1px solid #cccccc',
        marginBottom: "20px",
        marginRight: "30px",
        marginLeft: "30px"
    },
    closeButton: {
        position: 'absolute',
        right: 0,
        top: 0,
    },
    appBar: {
        position: 'relative',
    },
    children_container: {
        padding: "20px",
        marginRight: "30px",
        marginLeft: "30px"
    }
})

const DialogTitle = ({ children, onClose, ...props }) => {
    const classes = useStyles()
    return (
        <MuiDialogTitle disableTypography className={classes.title} {...props}>
          <Typography variant="h6">{children}</Typography>
          {onClose ? (
              <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
                <CloseIcon />
              </IconButton>
          ) : null}
        </MuiDialogTitle>
    )
}

export const Modal = ({title, children, onClose, fullScreen, ...props}) => {
    const classes = useStyles()

    return (

        <Dialog open={true}
                onClose={onClose}
                fullScreen={fullScreen===true}
                aria-labelledby="customized-dialog-title"
                {...props}
        >
          <>
            {title &&
             <DialogTitle id="customized-dialog-title" onClose={onClose}>
               {title}
             </DialogTitle>
            }
          </>
          <div className={classes.children_container}>
            {children}
          </div>
        </Dialog>

    )
    
}
